import React, { useState } from "react";
import { DateTime } from "luxon";
import { Pill } from "../../common/DataList";
import colors from "../../../helpers/colors";
import {
  CATEGORIE_LABELS,
  STATUT_PRESENTATION,
  getTypeLabel,
  formatSynchroFTData,
} from "./synchroFTLabels";

const STATUT_TONES = { success: "ok", warning: "warn", danger: "ko" };

const getPresentation = (statut) =>
  STATUT_PRESENTATION[statut] ?? { label: statut, color: "secondary", icon: "question" };

// Corps d'un événement Synchro France Travail : détail de l'échange,
// historique des tentatives (repliable) et date de mise à jour.
export const TimelineEventSynchroFTBody = ({ event }) => {
  const { type, data, updatedAt, tentatives } = event.synchroFT;
  const [tentativesOpen, setTentativesOpen] = useState(false);
  const rows = formatSynchroFTData(type, data);
  const tentativesList = tentatives ?? [];

  return (
    <div className="tl__body">
      {rows.length > 0 && (
        <dl className="tl-ft__rows">
          {rows.map((row, idx) => (
            <div key={`${event.id}-row-${idx}`} className="tl-ft__row">
              <dt>{row.label}</dt>
              <dd>{row.value}</dd>
            </div>
          ))}
        </dl>
      )}

      {tentativesList.length > 0 && (
        <div className="tl-ft__attempts">
          <button
            type="button"
            className="btn btn-link p-0 tl-ft__attempts-toggle"
            aria-expanded={tentativesOpen}
            onClick={() => setTentativesOpen((v) => !v)}
          >
            <i
              className={`fa fa-chevron-${tentativesOpen ? "down" : "right"} mr-1`}
              aria-hidden="true"
            />
            Historique des tentatives ({tentativesList.length})
          </button>
          {tentativesOpen && (
            <ul>
              {tentativesList.map((t, idx) => (
                <li key={`${event.id}-tent-${idx}`}>
                  <span>{DateTime.fromISO(t.date).toFormat("dd/MM/yyyy à HH:mm")}</span>
                  {t.erreur && <span className="tl-ft__error"> — {t.erreur}</span>}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}

      <p className="tl-ft__updated">
        Mis à jour le {DateTime.fromISO(updatedAt).toFormat("dd/MM/yyyy à HH:mm")}
      </p>
    </div>
  );
};

// Événement Synchro FT prêt pour le composant Timeline du kit.
export const buildSynchroFTItem = (event) => {
  const { categorie, type, statut } = event.synchroFT;
  const presentation = getPresentation(statut);

  return {
    id: event.id,
    date: event.date,
    icon: "sync",
    color: colors[presentation.color],
    variant: "ft",
    badges: (
      <>
        <Pill tone="dark">France Travail</Pill>
        <Pill tone="muted">{CATEGORIE_LABELS[categorie] ?? categorie}</Pill>
        <Pill tone={STATUT_TONES[presentation.color] ?? "neutral"} icon={`fa-${presentation.icon}`}>
          {presentation.label}
        </Pill>
      </>
    ),
    title: getTypeLabel(type),
    body: <TimelineEventSynchroFTBody event={event} />,
  };
};

export default TimelineEventSynchroFTBody;
